import classNames from "classnames";
import { NavLink, useMatch, useNavigate } from "react-router-dom";
import { ChangeEvent } from "react";
import { Tab } from "../interface";

interface IProps {
  tabs: Array<Tab>;
  baseURL: string;
  styles?: {
    container?: string;
    tab?: string;
  };
  GetMixpanelContext?: any;
}

export default function TabsTwo({
  tabs = [],
  baseURL = "",
  styles = {},
  GetMixpanelContext
}: IProps) {
  const navigate = useNavigate();
  const { trackUserAction } = GetMixpanelContext();

  function onMobileSelect(e: ChangeEvent<HTMLSelectElement>) {
    const tabHref = e.currentTarget.value;
    navigate(tabHref);
  }

  return (
    <div>
      <div className="md:hidden">
        <label htmlFor="tabs" className="sr-only">
          Select a tab
        </label>
        <select
          id="tabs"
          name="tabs"
          className="block w-full rounded-md border-gray-300 focus:border-indigo-500 focus:ring-indigo-500"
          defaultValue={tabs.find((tab) => tab?.current)?.name ?? ""}
          onChange={onMobileSelect}
        >
          {tabs.map((tab) => {
            const url = `${baseURL}${tab.href}`;

            return (
              <option key={tab.name} value={url}>
                {tab.name}
              </option>
            );
          })}
        </select>
      </div>
      <div className="hidden sm:block">
        <nav
          className={classNames(
            "inline-flex border rounded-lg",
            styles.container || ""
          )}
          aria-label="Index"
        >
          {tabs.map((tab) => {
            const url = `${baseURL}${tab.href}`;
            const matchData = useMatch(url);
            const isActive = matchData !== null;
            return (
              <NavLink
                key={tab.name}
                to={url}
                className={classNames(
                  "py-2.5 px-4 text-xs font-medium first:border-0 border-l first:rounded-l-lg last:rounded-r-lg",
                  isActive
                    ? "bg-[#F0F0F1] text-[#4C4C4D]"
                    : "bg-white text-[#626262]"
                )}
                aria-current={isActive ? "page" : undefined}
                onClick={(e) => {
                  e.currentTarget.scrollIntoView({
                    behavior: "smooth",
                    block: "nearest"
                  });
                  trackUserAction("loan_application_underwriting_tab_change", {
                    parentTab: "underwriting",
                    tab: tab.name
                  });
                }}
              >
                <span>{tab.name}</span>
              </NavLink>
            );
          })}
        </nav>
      </div>
    </div>
  );
}
